import {
  UsersIcon,
  ApplicationIcon,
  AclIcon,
  RoleIcon,
  LogoutIcon
} from "@gsd/backoffice-ui";
import React from "react";

type MenuType = {
    key: string,
    img: Function,
    route: string,
    description: string,
    label: string
}

const IDM_MENU: Array<MenuType> = [
  {
    key: "Utenti",
    img: () => (<UsersIcon fill="#FFF" width={32}/>),
    label : "Utenti",
    route: "/users",
    description: "Utenti e permessi"
  },
  {
    key: "Applicazioni",
    img: () => (<ApplicationIcon fill="#FFF" width={32}/>),
    label : "Applicazioni",
    route: "/applications",
    description: "Applicazioni",
  },
  {
    key: "Ruoli",
    img: () => (<RoleIcon fill="#FFF" width={32}/>),
    label : "Ruoli",
    route: "/roles",
    description: "Ruoli",
  },
  {
    key: "Controllo Accessi",
    img: () => (<AclIcon fill="#FFF" width={32}/>),
    label : "Controllo Accessi",
    route: "/acl",
    description: "Controllo accessi"
  },
  {
    key: "logout",
    img: () => (<LogoutIcon fill="#FFF" width={32}/>),
    route: "/logout",
    label: "Esci",
    description: "Logout",
  }
];

export type{ MenuType };
export { IDM_MENU };
